import { render } from "./login-panel.vue?vue&type=template&id=6ef33776&scoped=true&ts=true"
import script from "./login-panel.vue?vue&type=script&lang=ts"
export * from "./login-panel.vue?vue&type=script&lang=ts"

import "./login-panel.vue?vue&type=style&index=0&id=6ef33776&scoped=true&lang=less"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef33776"]])

export default __exports__